import React from 'react';
import { BarChart, Bar, XAxis, YAxis, ZAxis, CartesianGrid, Tooltip, Legend, Label, ResponsiveContainer } from 'recharts';
import blue from '@material-ui/core/colors/blue';

export default function Chart(data) {
  return (
    <React.Fragment>
      <ResponsiveContainer height="100%">
        <BarChart
          height={500}
          width={800}
          data={data.data}
          margin={{
            top: 20,
            right: 5,
            bottom: 30,
            left: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />

          <XAxis dataKey="Date"/>
          <YAxis/>
          <Tooltip/>
          <Bar dataKey="Total" barSize={30} fill={blue[400]} unit="L"/>

        </BarChart>
      </ResponsiveContainer>
    </React.Fragment>
  );
}
